import { ReactElement } from 'react';

import {
  Button,
  ListBox,
  MenuSearch,
  MenuSearchField,
  SelectMenuRoot,
  Text,
} from '@spotify-internal/encore-web';
import { Popover } from '@spotify-internal/encore-web/next';

import { useAccounts } from '../../hooks';
import {
  WorkspaceSelectTriggerContent,
  renderWorkspaceOptions,
} from './WorkspaceSelectContent';

export const WorkspacePicker = (): ReactElement | null => {
  const { accounts, selectedAccount, switchAccount, isLoading, isSwitching } =
    useAccounts();

  if (accounts.length === 0) {
    return null;
  }

  return (
    <SelectMenuRoot
      aria-label="Workspace"
      value={selectedAccount?.accountId ?? null}
      isDisabled={isLoading || isSwitching}
      onChange={value => {
        if (typeof value === 'string' && value !== selectedAccount?.accountId) {
          void switchAccount(value);
        }
      }}
     data-track-source-anchor="b6489951cb">
      <Button
        variant="tertiary"
        size="small"
        semanticColor="textBase"
        isCondensedInline
        hasNoInteractiveBackground
       data-track-source-anchor="a62c141f4f;workspace-picker-button">
        <WorkspaceSelectTriggerContent selectedAccount={selectedAccount} />
      </Button>
      <Popover>
        <MenuSearch>
          <MenuSearchField
            aria-label="Search workspaces"
            placeholder="Search workspaces"
          />
          <ListBox
            rowSize="small"
            aria-label="Workspaces"
            emptyState={<Text>No matching workspaces</Text>}
          >
            {renderWorkspaceOptions(accounts)}
          </ListBox>
        </MenuSearch>
      </Popover>
    </SelectMenuRoot>
  );
};
